import {httpConstants} from "../constants";
import {httpService} from "../utility/httpService";

export default {
    loginAdmin,
    getUserList,
    getUserDetails,
    forgotPassword,
    resetPassword,
    verifyEmailAndSendOtp,
    updateUser
}


function getHeaders() {
    return {'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON, 'skip': true}
}

async function loginAdmin(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.ADMIN_LOGIN;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};

async function getUserList(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.USER_LIST;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};

async function getUserDetails(requestData) {
    let url = process.env.REACT_APP_USER_SERVICE_URL + httpConstants.API_END_POINT.USER + '/' + requestData.userId;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {

                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};

async function verifyEmailAndSendOtp(requestData) {
    let url = process.env.REACT_APP_USER_SERVICE_URL + httpConstants.API_END_POINT.VERIFY_EMAIL_AND_SEND_OTP;
    // let url = 'http://localhost:3001' + httpConstants.API_END_POINT.VERIFY_EMAIL_AND_SEND_OTP;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};

async function forgotPassword(requestData) {
    let url = process.env.REACT_APP_USER_SERVICE_URL + httpConstants.API_END_POINT.FORGOT_PASSWORD;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {

                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};

async function resetPassword(requestData) {
    let url = process.env.REACT_APP_USER_SERVICE_URL + httpConstants.API_END_POINT.RESET_PASSWORD;
    // let url = 'http://localhost:3001' + httpConstants.API_END_POINT.RESET_PASSWORD;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {

                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};

async function updateUser(requestData, userId) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.USER + '?userId=' + userId;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), requestData, url)
        .then(
            response => {

                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
};
